import type { BankAccountType } from '@api';
import { Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { ViewDeletedBankAccountForm } from './components';

export type ViewDeletedBankAccountModalPropsType = {
  opened: boolean;
  onClose: () => void;
  bankAccount: BankAccountType | null;
};

export const ViewDeletedBankAccountModal: React.FC<
  ViewDeletedBankAccountModalPropsType
> = ({ opened, onClose, bankAccount }) => {
  const { t } = useTranslation('common');

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      size="lg"
      title={t('VIEW_DELETED_BANK_ACCOUNT_MODAL.TITLE')}
      closeOnClickOutside={false}
    >
      {bankAccount && (
        <ViewDeletedBankAccountForm
          key={bankAccount.id}
          bankAccount={bankAccount}
          onClose={onClose}
        />
      )}
    </Modal>
  );
};
